/**
 * Navigation component.
 */
export function Navigation() {
  /**
   * Toggle the visibility of a sub nav.
   */
  const toggleSubnavVisibility = (subNav) => {
    if (subNav) {
      // if the sub nav is hidden
      if (subNav.hasAttribute('hidden')) {
        subNav.removeAttribute('hidden');
      } else {
        subNav.setAttribute('hidden', '');
      }
    }
  };

  /**
   * Set aria-expanded and toggle visibility of sub nav.
   * param {object} toggleBtn - toggle button element
   * param {object} subNav - sub nav element
   */
  const toggleSubnav = (toggleBtn, subNav) => {
    if (toggleBtn.hasAttribute('aria-expanded')) {
      toggleBtn.setAttribute('aria-expanded', !(toggleBtn.getAttribute('aria-expanded') === 'true'));
    }
    toggleSubnavVisibility(subNav);
  };

  /**
   * Add event listeners to sub nav toggle buttons.
   */
  const addSubNavToggleListeners = () => {
    const subNavToggles = document.querySelectorAll('.nav__item--has-toggle button');
    subNavToggles.forEach((subNavToggle) => {
      const subNavHeader = subNavToggle.closest('.nav__item--has-toggle');
      const subNav = subNavHeader.nextElementSibling;
      subNavToggle.addEventListener('click', (event) => {
        toggleSubnav(event.target, subNav);
      });
      subNavToggle.addEventListener('mouseover', (event) => {
        toggleSubnav(event.target, subNav);
      });
      subNav.addEventListener('mouseleave', () => {
        toggleSubnav(subNavToggle, subNav);
      });
    });
  };

  /**
   * Add event listener to main Menu toggle button for Mobile
   */
  const addMainSiteNavToggleListener = () => {
    const mainSiteNavToggleBtn = document.querySelector('.nav--primary .header__nav-control');

    mainSiteNavToggleBtn.addEventListener('click', (event) => {
      const toggleBtn = event.target.closest('.header__nav-control');
      const toggleBtnIcon = toggleBtn.querySelector('.icon use');
      if (toggleBtn.hasAttribute('aria-expanded')) {
        toggleBtn.setAttribute('aria-expanded', !(toggleBtn.getAttribute('aria-expanded') === 'true'));
        document.getElementById('nav-primary').classList.toggle('nav__list--active');
        document.body.classList.toggle('no-scroll');

        // toggle Aria Label
        const label = toggleBtn.querySelector('.menu__action');
        label.textContent = label.textContent.startsWith('open') ? label.textContent.replace('open', 'close') : label.textContent.replace('close', 'open');
        label.textContent = ('aria-label', label);
      }
      if (toggleBtnIcon) {
        let iconURL = toggleBtnIcon.getAttribute('href');
        iconURL = iconURL.endsWith('hamburger') ? iconURL.replace('hamburger', 'close') : iconURL.replace('close', 'hamburger');
        toggleBtnIcon.setAttribute('href', iconURL);
      }
    });
  };

  /**
   * add event listener to category nav toggle button for Archive pages
   */
  const addCategoryNavToggleListener = () => {
    const categoryNavToggleBtn = document.querySelector('nav.page-archive__categories-menu .category-toggle');

    if (categoryNavToggleBtn) {
      categoryNavToggleBtn.addEventListener('click', (event) => {
        const toggleBtn = event.target.closest('.category-toggle');
        if (toggleBtn.hasAttribute('aria-expanded')) {
          toggleBtn.setAttribute('aria-expanded', !(toggleBtn.getAttribute('aria-expanded') === 'true'));
        }
      });
    }
  };

  /**
   * Initialize our component.
   */
  const init = () => {
    addSubNavToggleListeners();
    addMainSiteNavToggleListener();
    addCategoryNavToggleListener();
  };
  init();
}
